import React from "react";

export function Bone({
  w = "100%",
  h = 14,
  br = 3,
  style,
}: {
  w?: string | number;
  h?: number;
  br?: number;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className="skel"
      style={{ width: w, height: h, borderRadius: br, ...style }}
    />
  );
}
